import { b as _defineProperty, _ as _getPrototypeOf, a as _possibleConstructorReturn, c as _inherits, d as _classCallCheck, e as _createClass, Q } from '../_chunks/dep-b05afc19.js';
import { IconBase } from '../icon.js';
import '../util/classname.js';
import '../util/size-props.js';
import '../util/check-url-and-load.js';

var _class;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var element = {
  "attributes": {
    "fill": "none",
    "viewBox": "0 0 24 24",
    "width": "1em",
    "height": "1em"
  },
  "nodeName": "svg",
  "children": [{
    "attributes": {
      "fill": "currentColor",
      "d": "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM8.81753 7.40346L11.9999 10.5858L15.1815 7.40414L16.5957 8.81835L13.4141 12L16.5957 15.1816L15.1815 16.5958L11.9999 13.4142L8.81753 16.5965L7.40332 15.1823L10.5856 12L7.40332 8.81767L8.81753 7.40346Z"
    },
    "nodeName": "path",
    "children": []
  }]
};
var CloseCircleFilledIcon = (_class = /*#__PURE__*/function (_IconBase) {
  _inherits(CloseCircleFilledIcon, _IconBase);
  var _super = _createSuper(CloseCircleFilledIcon);
  function CloseCircleFilledIcon() {
    var _this;
    _classCallCheck(this, CloseCircleFilledIcon);
    _this = _super.call(this);
    _this.props = _objectSpread(_objectSpread({}, _this.props), {}, {
      id: "close-circle-filled"
    });
    return _this;
  }
  return _createClass(CloseCircleFilledIcon);
}(IconBase), _defineProperty(_class, "icon", element), _class);
CloseCircleFilledIcon = __decorateClass([Q("t-icon-close-circle-filled")], CloseCircleFilledIcon);

export default CloseCircleFilledIcon;
//# sourceMappingURL=close-circle-filled.js.map
